<template>
  <div style="margin-top:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Manage Users</span><br/>
      <span style="font-style: italic; font-size: 18px">All users across every tenant in the system.</span>
    </div>

    <div v-if="items" class="admin-users-toolbar">
      <span class="admin-users-count">{{items.length}} of {{items_full.length}}</span>
      <b-form-select size="sm" v-model="tenant_filter" :options="tenantOptions" class="admin-users-select"/>
      <b-form-select size="sm" v-model="tenant_type_filter" :options="tenantTypeOptions" class="admin-users-select"/>
      <b-form-select size="sm" v-model="role_filter" :options="roleOptions" class="admin-users-select"/>
      <b-form-select size="sm" v-model="logged_in_since_filter" :options="loggedInSinceOptions" class="admin-users-select"/>
      <b-form-checkbox size="sm" v-model="technical_contact_filter" class="admin-users-checkbox">Tech Contact</b-form-checkbox>
      <b-form-checkbox size="sm" v-model="no_tech_contact_filter" class="admin-users-checkbox">No TC</b-form-checkbox>
      <b-button
        size="sm"
        variant="outline-secondary"
        title="Download filtered results as CSV"
        :disabled="loading || !items.length"
        @click="downloadCsv"
      >
        <i class="fa fa-download" aria-hidden="true"></i>
      </b-button>
    </div>

    <div style="margin:20px">
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="username" slot-scope="row">
          <router-link :to="{ path: 'user_detail?username=' + encodeURIComponent(row.item.username)}">{{row.item.username}}</router-link>
        </template>

        <template slot="role" slot-scope="row">
          {{ roleDisplayLabel(row.item.role) }}
        </template>

        <template slot="accounts" slot-scope="row">
          <span v-for="tenant in row.item.accounts.split(',')" :key="tenant">
            {{tenant}}<br/>
          </span>
        </template>

        <template slot="tenant_types" slot-scope="row">
          {{ row.item.tenant_types }}
        </template>

        <template slot="technical_contact" slot-scope="row">
          <b-form-checkbox
            v-model="row.item.technical_contact"
            @change="toggle_technical_contact(row.item)"
          ></b-form-checkbox>
        </template>

        <template slot="last_login_time" slot-scope="row">
          {{row.item.last_login_time | formatDateTime}}
        </template>

        <template slot="actions" slot-scope="row">
            <b-button
              size="sm"
              title="Reset password"
              aria-label="Reset password"
              @click="reset_user_password(row.item.username)"
            >
              <i class="fa fa-key" aria-hidden="true"></i>
            </b-button>&nbsp;
            <b-button
              size="sm"
              variant="outline-danger"
              title="Delete user"
              aria-label="Delete user"
              @click="delete_user(row.item.username)"
            >
              <i class="fa fa-trash" aria-hidden="true"></i>
            </b-button>
        </template>
      </b-table>
    <b-row>
      <b-col>
        <b-pagination
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="perPage"
            align="center"
        >
        </b-pagination>
      </b-col>
    </b-row>
    </div>

  </div>
</template>

<script>

    import {get_all_users, update_user_technical_contact, delete_user_account} from '../networking/apis'
    import {mapState} from "vuex";
    import axios from "axios";

    export default {
      name: 'admin_manage_users',

      data() {
        return {
          items: [],
          items_full: [],
          loading: true,
          tenant_filter: '',
          tenant_type_filter: '',
          role_filter: '',
          technical_contact_filter: false,
          no_tech_contact_filter: false,
          logged_in_since_filter: '',
          currentPage: 1,
          perPage: 400,
          fields: [
            { key: 'username', label: 'Username', sortable: true},
            { key: 'first_name', label: 'First Name', sortable: true},
            { key: 'last_name', label: 'Last Name', sortable: true},
            { key: 'role', label: 'Role', sortable: true},
            { key: 'accounts', label: 'Tenant(s)', sortable: true, thStyle: { width: "250px" }},
            { key: 'tenant_types', label: 'Tenant Type(s)', sortable: true},
            { key: 'technical_contact', label: 'Technical Contact', sortable: true},
            { key: 'last_login_time', label: 'Last Login', sortable: true},
            { key: 'actions', label: 'Actions'},
          ],
          roleOptionsBase: [
            { value: 'admin', text: 'System Admin' },
            { value: 'customer-admin', text: 'Fleet Admin' },
            { value: 'tbn-admin', text: 'Fleet Admin (TBN)' },
            { value: 'customer', text: 'Staff' },
            { value: 'booking-customer', text: 'Booking Customer' },
            { value: 'driver', text: 'Driver' },
            { value: 'customer-care', text: 'Customer Care' },
            { value: 'manager', text: 'Manager' },
            { value: 'dispatch', text: 'Dispatch' },
            { value: 'garage', text: 'Garage' },
            { value: 'wash-bay', text: 'Wash Bay' },
            { value: 'other', text: 'Other' },
          ],
          loggedInSinceOptions: [
            { value: '', text: 'Any Login State' },
            { value: 'hour', text: 'Last Hour' },
            { value: 'day', text: 'Last Day' },
            { value: 'week', text: 'Last Week' },
            { value: 'month', text: 'Last Month' },
            { value: 'year', text: 'Last Year' },
            { value: 'never', text: 'Never' },
          ],
        }
      },

      async created() {
        await this.load_data()
      },
      methods: {
        async load_data() {
          this.loading = true
          try {
            const {value: { data = [] } } = await get_all_users()
            this.items_full = data.results
            this.filter_results()
          } catch(e) {
            this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
          }

          this.loading = false
        },
        async toggle_technical_contact(item) {
          try {
            await update_user_technical_contact(this.user.tenant, item.username, !item.technical_contact)
          } catch(e) {
            item.technical_contact = !item.technical_contact
            this.$emit('showAlert', 'error updating technical contact for ' + item.username, 'danger', 5000)
          }
        },
        async reset_user_password(username) {
          if (!confirm('Reset password for ' + username + '? A new password will be emailed to this user.'))
            return
          try{
              this.$emit('showAlert', "resetting password...", 'info')

              await axios.put(
                  process.env.VUE_APP_API_URL + "bookings/reset-password",
                  {username: username},
                  { headers: {'Access-Control-Allow-Origin': '*'}}
              )
              this.$emit('showAlert', "an email with a new password has been sent to " + username, 'success', 5000)

          } catch(e){
              e.response && e.response.data && e.response.data.message
              ? this.$emit('showAlert', e.response.data.message, 'danger')
              : this.$emit('showAlert', "reset password failed", 'danger')
          }
        },
        async delete_user(username) {
          if (!confirm('Delete user ' + username + '? This removes them from every tenant and cannot be undone.'))
            return
          this.$emit('showAlert', "deleting User..." + username, 'info')
          try {
            await delete_user_account(username)
            this.$emit('showAlert', "user " + username + " has been deleted", 'success', 5000)
            await this.load_data()
          } catch(e) {
            this.$emit('showAlert', "error deleting user " + username, 'danger', 5000)
          }
        },
        loggedInSinceCutoff(value) {
          const cutoff = new Date()
          if (value == 'hour')
            cutoff.setHours(cutoff.getHours() - 1)
          else if (value == 'day')
            cutoff.setDate(cutoff.getDate() - 1)
          else if (value == 'week')
            cutoff.setDate(cutoff.getDate() - 7)
          else if (value == 'month')
            cutoff.setMonth(cutoff.getMonth() - 1)
          else if (value == 'year')
            cutoff.setFullYear(cutoff.getFullYear() - 1)
          return cutoff
        },
        roleDisplayLabel(role) {
          const match = this.roleOptionsBase.find(o => o.value === role)
          return match ? match.text : role
        },
        csvEscapeField(val) {
          if (val == null || val === '')
            return ''
          const s = String(val)
          if (/[",\r\n]/.test(s))
            return `"${s.replace(/"/g, '""')}"`
          return s
        },
        csvExportCellValue(item, key) {
          if (key == 'role')
            return this.roleDisplayLabel(item.role)
          if (key == 'technical_contact')
            return item.technical_contact ? 'Yes' : 'No'
          return item[key]
        },
        downloadCsv() {
          const columns = this.fields.filter(field => field.key != 'actions')
          const lines = [columns.map(field => this.csvEscapeField(field.label || field.key)).join(',')]
          for (const item of this.items)
            lines.push(columns.map(field => this.csvEscapeField(this.csvExportCellValue(item, field.key))).join(','))

          const blob = new Blob([`\uFEFF${lines.join('\r\n')}`], { type: 'text/csv;charset=utf-8;' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'manage_users_' + new Date().toISOString().slice(0, 10) + '.csv'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          URL.revokeObjectURL(link.href)
        },
        userTenantIds(item) {
          return (item.tenant_id || '').split(',')
        },
        tenantIdsWithTechnicalContact() {
          const tenantIds = new Set()
          this.items_full.forEach(item => {
            if (item.technical_contact)
              this.userTenantIds(item).forEach(id => tenantIds.add(id))
          })
          return tenantIds
        },
        filter_results() {
          this.items = this.items_full
          if (this.role_filter != '')
            this.items = this.items.filter(item => item.role == this.role_filter)
          if (this.tenant_filter != '')
            this.items = this.items.filter(item => this.userTenantIds(item).includes(this.tenant_filter))
          if (this.tenant_type_filter != '')
            this.items = this.items.filter(item => (item.tenant_types || '').split(',').includes(this.tenant_type_filter))
          if (this.technical_contact_filter)
            this.items = this.items.filter(item => !!item.technical_contact)
          if (this.no_tech_contact_filter) {
            const tenantIdsWithTC = this.tenantIdsWithTechnicalContact()
            this.items = this.items.filter(item => !this.userTenantIds(item).some(id => tenantIdsWithTC.has(id)))
          }
          if (this.logged_in_since_filter == 'never') {
            this.items = this.items.filter(item => !item.last_login_time)
          } else if (this.logged_in_since_filter != '') {
            const cutoff = this.loggedInSinceCutoff(this.logged_in_since_filter)
            this.items = this.items.filter(item => item.last_login_time && new Date(item.last_login_time) >= cutoff)
          }
        },
      },
      computed:{
        ...mapState({
          user: state => state.profile.user
        }),
        roleOptions() {
          return [{ value: '', text: 'All Roles' }, ...this.roleOptionsBase]
        },
        tenantOptions() {
          const options = (this.user.tenant_options || []).slice().sort((a, b) => a.text.localeCompare(b.text))
          return [{ value: '', text: 'All Tenants' }, ...options]
        },
        tenantTypeOptions() {
          const types = this.user.types || {}
          const unique = [...new Set(Object.values(types).filter(Boolean))].sort()
          return [{ value: '', text: 'All Tenant Types' }, ...unique.map(t => ({ value: t, text: t }))]
        },
      },
      watch: {
        role_filter() {
          this.filter_results()
        },
        tenant_filter() {
          this.filter_results()
        },
        tenant_type_filter() {
          this.filter_results()
        },
        technical_contact_filter() {
          this.filter_results()
        },
        no_tech_contact_filter() {
          this.filter_results()
        },
        logged_in_since_filter() {
          this.filter_results()
        },
      }
    }
</script>

<style scoped>

  .admin-users-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin: 15px 10px 20px;
  }

  .admin-users-count {
    font-size: 14px;
    font-weight: 600;
    color: #555;
  }

  .admin-users-select {
    width: auto;
    min-width: 150px;
  }

  .admin-users-checkbox {
    font-size: 14px;
  }

</style>
